export default __webpack_public_path__ + "static/media/shopifyLogo.6d9b56d8.svg";